var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashOpened(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000081605569295321272490000012916086978497945486_);fill:none;stroke:#000000;stroke-width:48;stroke-linecap:round;stroke-miterlimit:10;}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000173128306955169546850000003753672444174018744_);fill:none;stroke:#000000;stroke-width:48;stroke-linecap:round;stroke-miterlimit:10;}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000088814403140213329920000004736570082573112487_);fill:none;stroke:#000000;stroke-width:48;stroke-linecap:round;stroke-miterlimit:10;}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000149381132410473522410000010118455837575167128_);fill:none;stroke:#000000;stroke-width:48;stroke-linecap:round;stroke-miterlimit:10;}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000181065423463789256130000014158599668992157627_);fill:none;stroke:#000000;stroke-width:48;stroke-linecap:round;stroke-miterlimit:10;}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000039117121525148459140000003261636542579509146_);fill:none;stroke:#000000;stroke-width:48;stroke-linecap:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Mirror_Repeat_x3E__00000056390081156240413270000005501382663549728913_"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 226.38,
    y: 225.54,
    width: 273.62,
    height: 634.38
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150070416727230755870000012348294009016947084_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000150070416727230755870000012348294009016947084_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 48,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M559.35,835.93c0,0-197.04,0-222.66,0c-28.47,0-46.9-16.06-50.6-42.7l-34.16-543.68H500"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Mirror_Repeat_x3E__00000106138519928864395680000009442947515814399157_"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000013908379653253884360000016039306150184465572_",
    x: 500,
    y: 225.54,
    width: 273.62,
    height: 634.38
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168825020508187001760000010446994138483330958_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013908379653253884360000016039306150184465572_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000168825020508187001760000010446994138483330958_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 48,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M440.65,835.93c0,0,197.04,0,222.66,0c28.47,0,46.9-16.06,50.6-42.7l34.16-543.68H500"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Mirror_Repeat_x3E__00000165214482749273375390000015847665706626588571_"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000003069215445839912410000011169416631901890218_",
    x: 343.47,
    y: 315.84,
    width: 183.14,
    height: 433.23
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044159142189198510540000000621902686286440615_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003069215445839912410000011169416631901890218_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000044159142189198510540000000621902686286440615_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 48,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 367.47,
    y1: 339.84,
    x2: 390.24,
    y2: 721.75
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000044159142189198510540000000621902686286440615_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 48,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 502.61,
    y1: 356.29,
    x2: 502.61,
    y2: 725.07
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Mirror_Repeat_x3E__00000057827253759988956020000005950102816294566577_"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000168805935940497224960000007039136838167650472_",
    x: 473.39,
    y: 315.84,
    width: 183.14,
    height: 433.23
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128469580106146557990000014595465724078077106_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168805935940497224960000007039136838167650472_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000128469580106146557990000014595465724078077106_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 48,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 632.53,
    y1: 339.84,
    x2: 609.76,
    y2: 721.75
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000128469580106146557990000014595465724078077106_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 48,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 497.39,
    y1: 356.29,
    x2: 497.39,
    y2: 725.07
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Mirror_Repeat_x3E__00000005243177970262511880000009531503923048488068_"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000121975584089640459740000014345322930666708099_",
    points: "406.49,18.18 454.9,221.39 123.59,221.39  123.59,18.18  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029035481662879385740000016158670105520901038_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121975584089640459740000014345322930666708099_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000029035481662879385740000016158670105520901038_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 48,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: " 147.59,197.39 325.27,155.06 440.12,127.7  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000029035481662879385740000016158670105520901038_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 48,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M434.69,42.18l-67.93,16.18c-22.77,5.42-40.39,24.25-33.13,54.71c8.87,37.23,8.87,37.23,8.87,37.23"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Mirror_Repeat_x3E__00000121992721791911601500000002089464673225346948_"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000112600051564725986130000010913430108711845784_",
    points: "406.49,18.18 454.9,221.39 750.62,72.01  659,-109.38  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061463748907409596710000008199903765346964889_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000112600051564725986130000010913430108711845784_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000061463748907409596710000008199903765346964889_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 48,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: " 718.38,61.41 540.7,103.74 425.86,131.1  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000061463748907409596710000008199903765346964889_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 48,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M392.14,52.31l67.93-16.18c22.77-5.42,46.99,3.44,54.24,33.9c8.87,37.23,8.87,37.23,8.87,37.23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashOpened);
export default __webpack_public_path__ + "static/media/trash_opened.acb487698b555b550a841138d13f5a0a.svg";
export { ForwardRef as ReactComponent };